import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/Button';

import DataTable from '../../DataTable/index.jsx';

import Columns from './Columns/index.jsx';
import { calculateHeldValue } from './Columns/calculateHeldValue.js'
import CurrencyFormat from '@scripts/utilities/currency.js';

import { fetch as fetchAssets, isAssetsLoading, getAssetById } from '../../../Store/assets.js';
import { fetch as fetchPortfolio, getAssetQuantityById } from '../../../Store/portfolio.js';
import { fetch as fetchUserPreferences, getUserPreferences, hidePortfolioTableColumn, setPortfoliosTableSort, showPortfolioTableColumn } from '../../../Store/user-preferences.js';

const PortfolioGroupList = function(props) {
  return (
    <>
      <DataTable
        loading={props.loading}
        fetch={props.fetch}
        columns={props.columns}
        rows={props.portfolios}
        columnVisibility={props.portfoliosTableColumns}
        hideColumn={props.hideColumn}
        showColumn={props.showColumn}
        sort={props.sort}
        setSort={props.setSort}
        noDataPlaceHolder={<label>To get started, <a href='#' onClick={(e) => {
          e.preventDefault();
          props.setPortfolio({});
        }}>add a New Portfolio</a></label>}
      />
      { !props.loading &&
      <div className='row'>
        <div className='col-md-6'>
          <div className='my-3'>
            <Button onClick={() => props.setPortfolio({})}>Add New Portfolio</Button>
        </div>
        </div>
        <div className="col-md-6 text-right">
            <p className='my-3'>
              <strong>
                Total value of all portfolios
              </strong><br/>
              <label>{CurrencyFormat(props.total)}</label>
            </p>
        </div>
      </div>
      }
    </>
  );
}


PortfolioGroupList.propTypes = {
  portfolios: PropTypes.array,
  selectPortfolio: PropTypes.func,
};
const priceChangeFields = [
  'priceChange7d',
  'priceChange24h',
  'priceChange30d',
  'priceChange60d',
  'priceChange1y',
]

const mapStateToProps = function(state, ownProps) {
  const { portfoliosTableColumns, PortfoliosTableSort, dashboard } = getUserPreferences(state);

  const additionalProps = {};
  const portfolios = [];

  if(dashboard?.portfolios?.length) {
    for(const portfolio of dashboard.portfolios) {
      const assets = [];
      const valueChanges = {};

      if(portfolio.assets) {
        for (const assetId of portfolio.assets) {
          const asset = getAssetById(state, assetId);
          if (asset) {
            const heldAmount = getAssetQuantityById(state, assetId, portfolio.id) || 0;
            const heldValue = heldAmount * asset.price;
            assets.push({...asset, heldAmount, heldValue, formattedTitle: `${asset.title} (${asset.ticker.toUpperCase()})`});
          }
        }
        // Calculate price changes for assets
        for(const priceChangeField of priceChangeFields) {
          valueChanges[priceChangeField] = calculateHeldValue(assets, priceChangeField);
        } 
      }

      // Assets should be in order of held value, then alphabetical
      assets.sort((a, b) => {
        if (b.heldValue !== a.heldValue) {
          return b.heldValue - a.heldValue;
        } else {
          return a.title?.localeCompare(b.title);
        }
      });

      portfolios.push({
        ...portfolio,
        ...valueChanges,
        assets,
        heldValue: assets.reduce((sum, asset) => sum + asset.heldValue, 0),
        selectPortfolio: ownProps.selectPortfolio,
        selected: portfolio.id === ownProps.selectedPortfolioId,
      })
    }
  }

  additionalProps.loading = isAssetsLoading(state);
  additionalProps.portfoliosTableColumns = portfoliosTableColumns;
  additionalProps.sort = PortfoliosTableSort;
  additionalProps.portfolios = portfolios;
  additionalProps.columns = Columns();
  additionalProps.total = portfolios.filter(portfolio => Boolean(portfolio.heldValue)).reduce((sum, portfolio) => sum + portfolio.heldValue, 0);
  
  return additionalProps;
};

const mapDispatchToProps = function(dispatch) {
  return {
    fetch: function() {
      dispatch(fetchUserPreferences());
      dispatch(fetchAssets());
      dispatch(fetchPortfolio());
    },
    hideColumn: function(column) {
      dispatch(hidePortfolioTableColumn(column));
    },
    setSort: function(column) {
      dispatch(setPortfoliosTableSort(column));
    },
    showColumn: function(column) {
      dispatch(showPortfolioTableColumn(column));
    },
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(PortfolioGroupList);

